import React from "react";

interface LoadingSpinnerProps {
  /** When true, renders a compact spinner for inline/section use instead of full page */
  compact?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ compact = false }) => {
  return (
    <div
      className={`loading-container ${
        compact ? "loading-container--compact" : ""
      }`}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: compact ? "auto" : "100vh",
        minHeight: compact ? "160px" : undefined,
        flexDirection: "column",
      }}
    >
      <div
        className="donut-loader"
        style={{
          width: compact ? "48px" : "80px",
          height: compact ? "48px" : "80px",
          border: compact ? "4px solid #f3f3f3" : "8px solid #f3f3f3",
          borderTop: compact ? "4px solid #3366cc" : "8px solid #3366cc",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}
      />
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <p
        style={{
          marginTop: compact ? "12px" : "20px",
          color: "#666",
          fontSize: compact ? "13px" : undefined,
        }}
      >
        Loading data...
      </p>
    </div>
  );
};

export default LoadingSpinner;
